// Vendor imports
const Immutable = require('immutable')
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class CommentModelRecord extends Immutable.Record({
  'created_at': Number(),
  id: Number(),
  'modified_at': Number(),
  'photo_url': String(),
  text: String(),
  'url_id': String(),
  'user_id': Number(),
  username: String()
}) {
  // No methods
}

CommentModelRecord.reviver = keyedReviver(CommentModelRecord, {
  // No nested data structures
})

module.exports = CommentModelRecord
